import { Cookies } from "react-cookie"
import { clearAccessTokenFromNative, syncAccessTokenWithNative } from "./TellingPapaAppBridge.js"
import butterflyApi from '../ButterflyApi';

const cookies = new Cookies()

export const setCookie = (name, value, option) => {
  return cookies.set(name, value, { ...option, path: "/" })
}

export const getCookie = (name) => {
  return cookies.get(name)
}

export const removeCookie = (name) => {
  return cookies.remove(name, { path: "/" })
}

const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60

export const login = async (accessToken) => {
  localStorage.removeItem("heroes")
  setCookie("accessToken", accessToken, { maxAge: SEVEN_DAYS_IN_SECONDS })
  syncAccessTokenWithNative(accessToken)

  const heroesResponse = await butterflyApi.getHeroes()
  if (heroesResponse && heroesResponse.items.length > 0) {
    const heroes = heroesResponse.items
    localStorage.setItem("heroes", JSON.stringify(heroes))
    const heroNo = localStorage.getItem("heroNo")
    if (heroes.filter(_hero => String(_hero.heroNo) === String(heroNo)).length === 0) {
      localStorage.setItem("heroNo", heroes[0].heroNo)
    }

  }

}

export const logout = () => {
  const accessToken = getCookie("accessToken")
  localStorage.clear()
  clearAccessTokenFromNative(accessToken)
  removeCookie("accessToken")
}


export const isLogin = () => {
  return cookies.get("accessToken")
}
